define('module/deeplink',[
    'jquery',
    'underscore',
    'cnf',
    '_pubsub',
    'scrollTo'
], function($, _, Cnf, Pubsub) {
    'use strict';
    
    return function()
    {
        var oPubsub=new Pubsub;
        
        this.options={
            selector:'a[href^="#"], a[href^="' + window.cnf.current.url + '#"]',
            data:{
                execute:'execute'
            },
            tween:{
                duration:1.2,
                offset:-20,
                offsetDesktop: -134,
                offsetMobile: -50,
                ease:Power2.easeInOut
            }
        };
        
        this.init=function()
        {
            this.initOptions();
            this.initEvent();
            this.initElement();
            this.initDeeplink();
        };
        
        this.initOptions=function()
        {
            this.$deeplink=Cnf.$body.find(this.options.selector);
            this.iDeeplink=this.$deeplink.length;
        };
        
        this.initEvent=function()
        {
            oPubsub.on(Pubsub.DEEPLINK_GOTO,_.bind(this.gotoHash,this));
        };
        
        this.initElement=function()
        {
            if(this.iDeeplink>0) {
            
                for(var i=0;i<this.iDeeplink;i++) {
                    //marked items are handled by other applications
                    if(typeof this.$deeplink.eq(i).data(this.options.data.execute)==='string') {
                        continue;
                    }
                    
                    this.$deeplink.eq(i).on(Cnf.click, _.bind(this.goto,this));
                }
            }
        };
        
        this.goto=function(ev)
        {
            var $el=Cnf.$app.find(ev.currentTarget.hash);

            //first try: get appropriate element
            if($el.length>0) {
                ev.preventDefault();
                var offset = (Cnf.isMobile || Cnf.isTablet) ? this.options.tween.offsetMobile : this.options.tween.offsetDesktop;
                offset = offset + (Cnf.loggedIn ? -32 : 0);
                this.scrollTo($el.offset().top + offset);
            }

            //second try: get appropriate modalbox
            $el = Cnf.$app.find('[data-modalbox="' + ev.currentTarget.hash.replace('#','') + '"]');
            if($el.length>0) {
                oPubsub.trigger(Pubsub.LIGHTBOX_SHOW, {
                    html: $el.find('script').first().html(),
                    size: "modalbox",
                    type: "modalbox",
                    colorscheme: $el.attr('data-colorscheme'),
                    lazyload: true,
                    tilewall: true,
                    flickity: true
                });
            }
        };
        
        this.gotoHash=function(hash)
        {
            var $el=Cnf.$app.find(hash);

            if($el.length>0) {
                var offset = (Cnf.isMobile || Cnf.isTablet) ? this.options.tween.offsetMobile : this.options.tween.offsetDesktop;
                offset = offset + (Cnf.loggedIn ? -32 : 0);
                this.scrollTo($el.offset().top + offset);
            }
        };
        
        this.scrollTo=function(y)
        {
            TweenMax.to(Cnf.$window, this.options.tween.duration, {
                scrollTo: {
                    y:y +this.options.tween.offset,
                    autoKill:false
                },
                ease:this.options.tween.ease
            });
        };

        /**
         * init deeplink
         * 
         * @jira FDZ-838
         * @date 2025-05-22
         * @author sh@moinbits.de
         */
        this.initDeeplink = function()
        {
            if(
                (typeof window.location.hash)
                && (window.location.hash.length > 0)
            ) {
                var deeplink = window.location.hash.replace('#', '');
                var $el = Cnf.$app.find('[data-initdeeplink="' + deeplink + '"]');
                if($el.length > 0) {

                    var offset = (Cnf.isMobile || Cnf.isTablet) ? this.options.tween.offsetMobile : this.options.tween.offsetDesktop;
                    offset = offset + (Cnf.loggedIn ? -32 : 0);
                    this.scrollTo($el.offset().top + offset);

                    //trigger method if given
                    var trigger = $el.data('deeplinktrigger');
                    if(typeof trigger === 'string')
                    {
                        switch(trigger) {
                            case 'details':
                                $el.find('details').attr('open','open');
                                break;

                            default:break;
                        }
                    }
                }
            }
        };
        
        this.init();
   };
});
